export enum EnumSideNavTypes {
  LINK = 0,
  BUTTON = 1,
}

export type MatTreeNode = {
  icon: string;
  id?: string;
  index?: number;
  name: string;
  options?: { params?: Record<string, unknown>; routerLink?: Array<number | string> | string };
  title?: string;
  translateIcon?: string;
  type: EnumSideNavTypes;
  visible?: boolean;
};

export type SideNavOptions = MatTreeNode & {
  children?: SideNavChild[];
};

type SideNavChild = MatTreeNode;

export class SideNavDataSource {
  public sideNavDataSource: SideNavOptions[] = [
    {
      children: [
        {
          icon: 'P',
          index: 0,
          name: 'Portfolio',
          options: { routerLink: ['/material-management/portfolio'] },
          title: 'portfolio',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'N',
          id: 'NotesAndComments',
          index: 26,
          name: 'Notes & Comments',
          options: { routerLink: ['/material-management/notes-and-comments'] },
          title: 'notesAndComments',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'P',
          index: 1,
          name: 'PartNumbers',
          options: { routerLink: ['/material-management/partnumbers'] },
          title: 'partNumbers',
          translateIcon: 'partNumbersIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'V',
          index: 2,
          name: 'Vendors',
          options: { routerLink: ['/material-management/vendors'] },
          title: 'vendors',
          translateIcon: 'vendorsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'V',
          index: 3,
          name: 'Vendor Codes Rights',
          options: { routerLink: ['material-management/vendorcodes-rights'] },
          title: 'vendorCodesRights',
          translateIcon: 'vendorCodesRightsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'C',
          index: 4,
          name: 'Contacts',
          options: { routerLink: ['/material-management/contacts'] },
          title: 'contacts',
          translateIcon: 'contactsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
      ],
      icon: 'dataset',
      name: 'PORTFOLIO',
      title: 'PORTFOLIO',
      type: EnumSideNavTypes.LINK,
      visible: true,
    },
    {
      children: [
        {
          icon: 'C',
          index: 5,
          name: 'Commits',
          options: { routerLink: ['material-management/commits'] },
          title: 'commits',
          translateIcon: 'commitsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'P',
          index: 6,
          name: 'PN Groups',
          options: { routerLink: ['material-management/pn-groups'] },
          title: 'pnGroups',
          translateIcon: 'pnGroupsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'Q',
          index: 7,
          name: 'QAP',
          options: { routerLink: ['/material-management/qap'] },
          title: 'QAP',
          translateIcon: 'qapIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        // {
        //   icon: 'R',
        //   index: 8,
        //   name: 'RFQ',
        //   options: { routerLink: ['/material-management/quotations'] },
        //   title: 'RFQ',
        //   translateIcon: 'rfqIcon',
        //   type: EnumSideNavTypes.LINK,
        //   visible: true,
        // },
        {
          icon: 'D',
          id: 'SCM Default Fields',
          index: 8,
          name: 'Default Fields',
          options: { routerLink: ['/material-management/default-fields'] },
          title: 'defaultFields',
          translateIcon: 'defaultFieldsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
      ],
      icon: 'inventory_2',
      name: 'SCM',
      title: 'SCM',
      type: EnumSideNavTypes.LINK,
      visible: true,
    },
    {
      children: [
        {
          icon: 'I',
          index: 9,
          name: 'Invoicing',
          options: { routerLink: ['/financial-module/invoicing'] },
          title: 'invoicing',
          translateIcon: 'invoicingIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'G',
          index: 10,
          name: 'Goods Receipts',
          options: { routerLink: ['/financial-module/goods-receipts'] },
          title: 'goodsReceipts',
          translateIcon: 'goodsReceiptsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'IR',
          index: 11,
          name: 'Invoice Reconciliation',
          options: { routerLink: ['/financial-module/invoice-reconciliation'] },
          title: 'invoiceReconciliation',
          translateIcon: 'invoiceReconciliationIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'D',
          id: 'Financial Module Default Fields',
          index: 12,
          name: 'Default Fields',
          options: { routerLink: ['/financial-module/default-fields'] },
          title: 'defaultFields',
          translateIcon: 'defaultFieldsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
      ],
      icon: 'account_balance',
      name: 'Financial Module',
      title: 'FINANCIALMODULE',
      type: EnumSideNavTypes.LINK,
      visible: true,
    },
    {
      children: [
        {
          icon: 'S',
          index: 13,
          name: 'Shipments',
          options: { routerLink: ['/material-management/shipments'] },
          title: 'shipments',
          translateIcon: 'shipmentsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'C',
          index: 14,
          name: 'Carriers',
          options: { routerLink: ['/material-management/carriers'] },
          title: 'carriers',
          translateIcon: 'carriersIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'S',
          index: 15,
          name: 'Stocks',
          options: { routerLink: ['/material-management/stocks'] },
          title: 'storageLocations',
          translateIcon: 'storageLocationsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'SU',
          index: 16,
          name: 'Shipments Update',
          options: { routerLink: ['/material-management/shipments-update'] },
          title: 'shipmentsUpdate',
          translateIcon: 'shipmentsUpdateIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'U',
          index: 17,
          name: 'Upload Documents',
          options: { routerLink: ['/material-management/upload-documents'] },
          title: 'uploadDocuments',
          translateIcon: 'uploadDocumentsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'GI',
          index: 18,
          name: 'Generate Instructions',
          options: { routerLink: ['/material-management/instructions'] },
          title: 'generateInstructions',
          translateIcon: 'generateInstructionsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'SS',
          index: 19,
          name: 'Slots Storage',
          options: { routerLink: ['/material-management/slots-storage'] },
          title: 'slotsStorage',
          translateIcon: 'slotsStorageIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'C',
          index: 20,
          name: 'Slot Calendar',
          options: { routerLink: ['/material-management/slot-calendar'] },
          title: 'slotsCalendar',
          translateIcon: 'slotsCalendarIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'S',
          index: 21,
          name: 'Slots',
          options: { routerLink: ['/material-management/slots'] },
          title: 'slots',
          translateIcon: 'slotsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
        {
          icon: 'D',
          id: 'Logistic Default Fields',
          index: 22,
          name: 'Default Fields',
          options: { routerLink: ['/logistic/default-fields'] },
          title: 'defaultFields',
          translateIcon: 'defaultFieldsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
      ],
      icon: 'local_shipping',
      name: 'Logistic',
      title: 'LOGISTICS',
      type: EnumSideNavTypes.LINK,
      visible: true,
    },
    {
      children: [
        {
          icon: 'A',
          index: 23,
          name: 'Audit Log',
          options: { routerLink: ['/financial-module/audit-log'] },
          title: 'auditLog',
          translateIcon: 'auditLogIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
      ],
      icon: 'timelapse',
      name: 'Activity',
      title: 'ACTIVITY',
      type: EnumSideNavTypes.LINK,
      visible: true,
    },
    {
      children: [
        {
          icon: 'GN',
          index: 24,
          name: 'Global Notifications',
          options: { routerLink: ['material-management/global-notifications'] },
          title: 'globalNotifications',
          translateIcon: 'globalNotificationsIcon',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
      ],
      icon: 'admin_panel_settings',
      name: 'Administration',
      title: 'ADMINISTRATION',
      type: EnumSideNavTypes.LINK,
      visible: true,
    },
    {
      children: [
        {
          icon: 'AI',
          index: 25,
          name: 'A.I. Chat',
          options: { routerLink: ['/dashboard/ai'] },
          title: 'aiChat',
          type: EnumSideNavTypes.LINK,
          visible: true,
        },
      ],
      icon: 'sms',
      name: 'Artificial Intelligence',
      title: 'ARTIFICIALINTELLIGENCE',
      type: EnumSideNavTypes.LINK,
      visible: true,
    },
  ];
}
